import React, { useState, useEffect, useCallback } from 'react';

// Geography and Language configuration - mirrored from backend
const GEOGRAPHY_CONFIG = {
  "United States": {
    code: "US",
    flag: "🇺🇸",
    currency: "USD",
    currencySymbol: "$",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "American" },
      { code: "es", name: "Spanish", nativeName: "Español", accent: "American Spanish" },
    ]
  },
  "United Kingdom": {
    code: "GB",
    flag: "🇬🇧",
    currency: "GBP",
    currencySymbol: "£",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "British" },
    ]
  },
  "India": {
    code: "IN",
    flag: "🇮🇳",
    currency: "INR",
    currencySymbol: "₹",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Indian English" },
      { code: "ta", name: "Tamil", nativeName: "தமிழ்", accent: "Tamil" },
      { code: "hi", name: "Hindi", nativeName: "हिन्दी", accent: "Hindi" },
      { code: "te", name: "Telugu", nativeName: "తెలుగు", accent: "Telugu" },
      { code: "bn", name: "Bengali", nativeName: "বাংলা", accent: "Bengali" },
      { code: "mr", name: "Marathi", nativeName: "मराठी", accent: "Marathi" },
      { code: "gu", name: "Gujarati", nativeName: "ગુજરાતી", accent: "Gujarati" },
      { code: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ", accent: "Kannada" },
      { code: "ml", name: "Malayalam", nativeName: "മലയാളം", accent: "Malayalam" },
      { code: "pa", name: "Punjabi", nativeName: "ਪੰਜਾਬੀ", accent: "Punjabi" },
    ]
  },
  "Australia": {
    code: "AU",
    flag: "🇦🇺",
    currency: "AUD",
    currencySymbol: "A$",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Australian" },
    ]
  },
  "Singapore": {
    code: "SG",
    flag: "🇸🇬",
    currency: "SGD",
    currencySymbol: "S$",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Singaporean" },
      { code: "zh", name: "Mandarin Chinese", nativeName: "中文", accent: "Singaporean Mandarin" },
      { code: "ms", name: "Malay", nativeName: "Bahasa Melayu", accent: "Singaporean Malay" },
      { code: "ta", name: "Tamil", nativeName: "தமிழ்", accent: "Singaporean Tamil" },
    ]
  },
  "Canada": {
    code: "CA",
    flag: "🇨🇦",
    currency: "CAD",
    currencySymbol: "C$",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Canadian" },
      { code: "fr", name: "French", nativeName: "Français", accent: "Canadian French" },
    ]
  },
  "Germany": {
    code: "DE",
    flag: "🇩🇪",
    currency: "EUR",
    currencySymbol: "€",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "German English" },
      { code: "de", name: "German", nativeName: "Deutsch", accent: "German" },
    ]
  },
  "France": {
    code: "FR",
    flag: "🇫🇷",
    currency: "EUR",
    currencySymbol: "€",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "French English" },
      { code: "fr", name: "French", nativeName: "Français", accent: "French" },
    ]
  },
  "Japan": {
    code: "JP",
    flag: "🇯🇵",
    currency: "JPY",
    currencySymbol: "¥",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Japanese English" },
      { code: "ja", name: "Japanese", nativeName: "日本語", accent: "Japanese" },
    ]
  },
  "Brazil": {
    code: "BR",
    flag: "🇧🇷",
    currency: "BRL",
    currencySymbol: "R$",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Brazilian English" },
      { code: "pt", name: "Portuguese", nativeName: "Português", accent: "Brazilian Portuguese" },
    ]
  },
  "Mexico": {
    code: "MX",
    flag: "🇲🇽",
    currency: "MXN",
    currencySymbol: "$",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Mexican English" },
      { code: "es", name: "Spanish", nativeName: "Español", accent: "Mexican Spanish" },
    ]
  },
  "Spain": {
    code: "ES",
    flag: "🇪🇸",
    currency: "EUR",
    currencySymbol: "€",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Spanish English" },
      { code: "es", name: "Spanish", nativeName: "Español", accent: "Castilian Spanish" },
      { code: "ca", name: "Catalan", nativeName: "Català", accent: "Catalan" },
    ]
  },
  "Italy": {
    code: "IT",
    flag: "🇮🇹",
    currency: "EUR",
    currencySymbol: "€",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Italian English" },
      { code: "it", name: "Italian", nativeName: "Italiano", accent: "Italian" },
    ]
  },
  "South Korea": {
    code: "KR",
    flag: "🇰🇷",
    currency: "KRW",
    currencySymbol: "₩",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Korean English" },
      { code: "ko", name: "Korean", nativeName: "한국어", accent: "Korean" },
    ]
  },
  "China": {
    code: "CN",
    flag: "🇨🇳",
    currency: "CNY",
    currencySymbol: "¥",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Chinese English" },
      { code: "zh", name: "Mandarin Chinese", nativeName: "中文", accent: "Mandarin" },
      { code: "yue", name: "Cantonese", nativeName: "廣東話", accent: "Cantonese" },
    ]
  },
  "UAE": {
    code: "AE",
    flag: "🇦🇪",
    currency: "AED",
    currencySymbol: "د.إ",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Middle Eastern English" },
      { code: "ar", name: "Arabic", nativeName: "العربية", accent: "Gulf Arabic" },
    ]
  },
  "Indonesia": {
    code: "ID",
    flag: "🇮🇩",
    currency: "IDR",
    currencySymbol: "Rp",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Indonesian English" },
      { code: "id", name: "Indonesian", nativeName: "Bahasa Indonesia", accent: "Indonesian" },
    ]
  },
  "Thailand": {
    code: "TH",
    flag: "🇹🇭",
    currency: "THB",
    currencySymbol: "฿",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Thai English" },
      { code: "th", name: "Thai", nativeName: "ภาษาไทย", accent: "Thai" },
    ]
  },
  "Vietnam": {
    code: "VN",
    flag: "🇻🇳",
    currency: "VND",
    currencySymbol: "₫",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Vietnamese English" },
      { code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt", accent: "Vietnamese" },
    ]
  },
  "Philippines": {
    code: "PH",
    flag: "🇵🇭",
    currency: "PHP",
    currencySymbol: "₱",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Filipino English" },
      { code: "fil", name: "Filipino", nativeName: "Filipino", accent: "Filipino" },
    ]
  },
  "Malaysia": {
    code: "MY",
    flag: "🇲🇾",
    currency: "MYR",
    currencySymbol: "RM",
    primaryLanguage: "English",
    languages: [
      { code: "en", name: "English", nativeName: "English", accent: "Malaysian English" },
      { code: "ms", name: "Malay", nativeName: "Bahasa Melayu", accent: "Malaysian Malay" },
      { code: "zh", name: "Mandarin Chinese", nativeName: "中文", accent: "Malaysian Mandarin" },
      { code: "ta", name: "Tamil", nativeName: "தமிழ்", accent: "Malaysian Tamil" },
    ]
  },
};

// Default config for unknown geographies
const DEFAULT_CONFIG = {
  code: "INTL",
  flag: "🌍",
  currency: "USD",
  currencySymbol: "$",
  primaryLanguage: "English",
  languages: [
    { code: "en", name: "English", nativeName: "English", accent: "International" },
  ]
};

/**
 * Get unique languages available for selected geographies
 */
const getAvailableLanguages = (selectedGeographies) => {
  if (!selectedGeographies || selectedGeographies.length === 0) {
    return DEFAULT_CONFIG.languages;
  }

  const languagesMap = new Map();
  
  selectedGeographies.forEach(geo => {
    const config = GEOGRAPHY_CONFIG[geo] || DEFAULT_CONFIG;
    config.languages.forEach(lang => {
      if (!languagesMap.has(lang.code)) {
        languagesMap.set(lang.code, lang);
      }
    });
  });

  return Array.from(languagesMap.values());
};

/**
 * Multi-select dropdown component with chips
 */
const MultiSelectDropdown = ({ 
  label, 
  options, 
  selectedValues, 
  onChange, 
  placeholder,
  renderOption,
  disabled = false,
  maxSelections = null,
  testId,
  valueKey = 'name' // 'name' for geography, 'code' for languages
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = React.useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleOption = (value) => {
    if (selectedValues.includes(value)) {
      onChange(selectedValues.filter(v => v !== value));
    } else {
      if (maxSelections && selectedValues.length >= maxSelections) {
        return; // Don't add more if at max
      }
      onChange([...selectedValues, value]);
    }
  };

  const handleOptionClick = (e, value, isDisabled) => {
    e.stopPropagation(); // Prevent dropdown from closing
    e.preventDefault();
    if (!isDisabled) {
      toggleOption(value);
    }
  };

  const removeOption = (value, e) => {
    e.stopPropagation();
    onChange(selectedValues.filter(v => v !== value));
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        {label}
      </label>
      
      {/* Selected chips display */}
      <div
        data-testid={testId}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        className={`min-h-[44px] w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg 
          ${disabled ? 'bg-gray-100 dark:bg-gray-700 cursor-not-allowed' : 'bg-white dark:bg-gray-800 cursor-pointer'}
          focus:ring-2 focus:ring-green-500 focus:border-transparent flex flex-wrap gap-2 items-center`}
      >
        {selectedValues.length === 0 ? (
          <span className="text-gray-400 dark:text-gray-500">{placeholder}</span>
        ) : (
          selectedValues.map(value => {
            const option = options.find(o => (typeof o === 'string' ? o : o[valueKey]) === value);
            const displayText = renderOption ? renderOption(option, true) : value;
            return (
              <span
                key={value}
                className="inline-flex items-center gap-1 px-2 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded-full text-sm"
              >
                {displayText}
                {!disabled && (
                  <button
                    onClick={(e) => removeOption(value, e)}
                    className="hover:bg-green-200 dark:hover:bg-green-800 rounded-full p-0.5"
                    data-testid={`remove-${value}`}
                  >
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </span>
            );
          })
        )}
        
        {/* Dropdown arrow */}
        <div className="ml-auto">
          <svg 
            className={`w-5 h-5 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      {/* Dropdown options */}
      {isOpen && !disabled && (
        <div className="absolute z-50 w-full mt-1 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {options.map((option, index) => {
            // Use specified valueKey to extract value
            const value = typeof option === 'string' ? option : option[valueKey];
            const isSelected = selectedValues.includes(value);
            const isDisabled = maxSelections && selectedValues.length >= maxSelections && !isSelected;
            
            return (
              <div
                key={value || index}
                onClick={(e) => handleOptionClick(e, value, isDisabled)}
                className={`px-4 py-2 cursor-pointer flex items-center justify-between
                  ${isSelected ? 'bg-green-50 dark:bg-green-900/30' : 'hover:bg-gray-100 dark:hover:bg-gray-700'}
                  ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                data-testid={`option-${value}`}
              >
                <span className="dark:text-white">
                  {renderOption ? renderOption(option, false) : value}
                </span>
                {isSelected && (
                  <svg className="w-5 h-5 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
            );
          })}
        </div>
      )}
      
      {/* Helper text for max selections */}
      {maxSelections && (
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          {selectedValues.length}/{maxSelections} selected
        </p>
      )}
    </div>
  );
};

/**
 * Geography and Language Selector Component
 * Supports multi-select for both geography and languages
 * Languages are filtered based on selected geographies
 */
const GeographyLanguageSelector = ({
  selectedGeographies = [],
  selectedLanguages = [],
  onGeographyChange,
  onLanguageChange,
  showLanguageSelector = true,
  maxGeographies = 5,
  maxLanguages = 3,
  disabled = false,
  className = ''
}) => {
  // Get available languages based on selected geographies
  const availableLanguages = useCallback(() => {
    return getAvailableLanguages(selectedGeographies);
  }, [selectedGeographies]);

  // Auto-select English as default when geography changes
  // Users can choose other languages from dropdown if needed
  useEffect(() => {
    if (selectedGeographies.length > 0 && selectedLanguages.length === 0) {
      const firstGeo = selectedGeographies[0];
      const config = GEOGRAPHY_CONFIG[firstGeo] || DEFAULT_CONFIG;
      // Always default to English if available, otherwise use primary language
      const englishLang = config.languages.find(l => l.code === 'en');
      if (englishLang) {
        onLanguageChange(['en']);
      } else {
        // Fallback to primary language if English not available for this geography
        const primaryLang = config.languages.find(l => l.name === config.primaryLanguage);
        if (primaryLang) {
          onLanguageChange([primaryLang.code]);
        }
      }
    }
  }, [selectedGeographies, selectedLanguages.length, onLanguageChange]);

  // Remove invalid languages when geography changes
  useEffect(() => {
    const available = availableLanguages();
    const availableCodes = available.map(l => l.code);
    const validLanguages = selectedLanguages.filter(code => availableCodes.includes(code));
    
    if (validLanguages.length !== selectedLanguages.length) {
      onLanguageChange(validLanguages);
    }
  }, [selectedGeographies, selectedLanguages, availableLanguages, onLanguageChange]);

  // All geography options
  const geographyOptions = Object.entries(GEOGRAPHY_CONFIG).map(([name, config]) => ({
    name,
    flag: config.flag,
    code: config.code,
    primaryLanguage: config.primaryLanguage
  }));

  // Add "Other" option
  geographyOptions.push({
    name: "Other",
    flag: "🌍",
    code: "INTL",
    primaryLanguage: "English"
  });

  const renderGeographyOption = (option, isChip) => {
    if (!option) return '';
    if (isChip) {
      return `${option.flag} ${option.name}`;
    }
    return (
      <span className="flex items-center gap-2">
        <span>{option.flag}</span>
        <span>{option.name}</span>
        <span className="text-xs text-gray-500">({option.primaryLanguage})</span>
      </span>
    );
  };

  const renderLanguageOption = (option, isChip) => {
    if (!option) return '';
    if (isChip) {
      return `${option.name}`;
    }
    return (
      <span className="flex items-center gap-2">
        <span className="font-medium">{option.name}</span>
        <span className="text-xs text-gray-500">({option.nativeName})</span>
        {option.accent && <span className="text-xs text-gray-400">• {option.accent}</span>}
      </span>
    );
  };

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Geography Multi-Select */}
      <MultiSelectDropdown
        label="Target Geographies"
        options={geographyOptions}
        selectedValues={selectedGeographies}
        onChange={onGeographyChange}
        placeholder="Select target countries..."
        renderOption={renderGeographyOption}
        disabled={disabled}
        maxSelections={maxGeographies}
        testId="geography-selector"
        valueKey="name"
      />

      {/* Language Multi-Select - Only show if geographies selected and showLanguageSelector is true */}
      {showLanguageSelector && selectedGeographies.length > 0 && (
        <MultiSelectDropdown
          label="Ad Languages (Each language = separate versions)"
          options={availableLanguages()}
          selectedValues={selectedLanguages}
          onChange={onLanguageChange}
          placeholder="Select languages for your ads..."
          renderOption={renderLanguageOption}
          disabled={disabled}
          maxSelections={maxLanguages}
          testId="language-selector"
          valueKey="code"
        />
      )}

      {/* Credit multiplier info box */}
      {showLanguageSelector && selectedGeographies.length > 0 && selectedLanguages.length > 0 && (
        <div className={`rounded-lg p-3 ${selectedLanguages.length > 1 ? 'bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800' : 'bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800'}`}>
          <div className="flex items-start gap-2">
            {selectedLanguages.length > 1 ? (
              <svg className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            ) : (
              <svg className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            )}
            <div className={`text-sm ${selectedLanguages.length > 1 ? 'text-amber-700 dark:text-amber-300' : 'text-blue-700 dark:text-blue-300'}`}>
              <p className="font-medium">
                {selectedLanguages.length > 1 
                  ? `${selectedLanguages.length} Language Versions Will Be Generated`
                  : 'Ad Language'
                }
              </p>
              <p className="text-xs mt-1">
                {selectedLanguages.length > 1 ? (
                  <>
                    Each language generates separate ad versions (videos with native voiceover, text ads translated).
                    <span className="font-semibold block mt-1">
                      Total cost: Base credits × {selectedLanguages.length} languages
                    </span>
                  </>
                ) : (
                  <>Ads will be generated in {availableLanguages().find(l => l.code === selectedLanguages[0])?.name || 'English'}.</>
                )}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Export helper functions for use in other components
export { 
  GEOGRAPHY_CONFIG, 
  DEFAULT_CONFIG, 
  getAvailableLanguages,
  MultiSelectDropdown 
};

export default GeographyLanguageSelector;
